import { BrowserRouter, Link, NavLink, Route, Routes } from "react-router-dom";

const PRODUCTS = [
  {
    slug: "lakashitel",
    name: "Lakáshitel",
    subtitle: "Találd meg a céljaidhoz illő jelzáloghitelt.",
    description:
      "Hasonlítsd össze több bank lakáshitel ajánlatát, és dönts adatok alapján a legkedvezőbb konstrukció mellett.",
    highlights: [
      "Versenyképes kamatok több banktól",
      "Személyre szabott szakértői támogatás",
      "Átlátható, gyors online folyamat",
    ],
  },
  {
    slug: "szemelyi-kolcson",
    name: "Személyi kölcsön",
    subtitle: "Gyors finanszírozás szabad felhasználásra.",
    description:
      "Pár perc alatt áttekintheted az elérhető személyi kölcsön ajánlatokat, hogy megtaláld a számodra legjobb havi törlesztőt.",
    highlights: [
      "Gyors ajánlatok, átlátható feltételek",
      "Akár online igénylési folyamat",
      "Költségek és THM egyszerű összevetése",
    ],
  },
  {
    slug: "bankszamla",
    name: "Bankszámla",
    subtitle: "Válassz költséghatékony számlacsomagot.",
    description:
      "Nézd meg, melyik bankszámla passzol a bankolási szokásaidhoz: utalás, kártyahasználat, készpénzfelvétel.",
    highlights: [
      "Akciós és kedvezményes számlacsomagok",
      "Várható havi költségek összehasonlítása",
      "Egyszerű váltási támogatás",
    ],
  },
  {
    slug: "babavaro-hitel",
    name: "Babaváró hitel",
    subtitle: "Támogatott hitel családalapításhoz.",
    description:
      "Ismerd meg a jogosultsági feltételeket, és számold ki, hogyan alakulhat a törlesztésed különböző élethelyzetekben.",
    highlights: [
      "Jogosultsági feltételek könnyen átláthatóan",
      "Támogatási előnyök és buktatók egy helyen",
      "Szakértői segítség az ügyintézés során",
    ],
  },
  {
    slug: "nyugdijbiztositas",
    name: "Nyugdíjbiztosítás",
    subtitle: "Építs stabil pénzügyi jövőt nyugdíjaskorra.",
    description:
      "Tervezd meg nyugdíjcélú megtakarításodat, és használd ki az állami adójóváírás adta lehetőségeket.",
    highlights: [
      "20% adójóváírás lehetősége",
      "Hosszú távú, tudatos pénzügyi tervezés",
      "Kockázathoz illeszkedő konstrukciók",
    ],
  },
];

const IFRAME_SOURCES = {
  "szemelyi-kolcson":
    "https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel",
  lakashitel: "https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel",
  bankszamla: "https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel",
  "babavaro-hitel":
    "https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel",
  nyugdijbiztositas:
    "https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel",
};

function SiteHeader() {
  return (
    <header className="site-header">
      <div className="shell header-inner">
        <Link className="brand" to="/">
          SzemélyiKölcsön.com
        </Link>
        <nav className="top-nav" aria-label="Fő navigáció">
          {PRODUCTS.map((product) => (
            <NavLink
              key={product.slug}
              to={`/${product.slug}`}
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              {product.name}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}

function HomePage() {
  return (
    <main>
      <section className="hero-section">
        <div className="shell">
          <p className="hero-kicker">Pénzügyi döntések egyszerűen</p>
          <h1>Találd meg gyorsan a hozzád illő pénzügyi megoldást</h1>
          <p className="hero-lead">
            Összehasonlítjuk a legfontosabb banki és biztosítási termékeket,
            hogy magabiztosan dönthess a következő pénzügyi lépésedről.
          </p>
        </div>
      </section>

      <section className="tile-section">
        <div className="shell">
          <h2>Kiemelt termékek</h2>
          <p className="section-lead">
            Válassz terméket, és nézd meg az összehasonlítást, feltételeket,
            valamint az azonnal használható kalkulátort.
          </p>
          <div className="tile-grid">
            {PRODUCTS.map((product) => (
              <article key={product.slug} className="tile-card">
                <h3>{product.name}</h3>
                <p>{product.subtitle}</p>
                <Link className="tile-link" to={`/${product.slug}`}>
                  Landing megnyitása
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

function LegalPage({ title, intro, sections }) {
  return (
    <main>
      <section className="hero-section legal-hero">
        <div className="shell">
          <p className="hero-kicker">Jogi információk</p>
          <h1>{title}</h1>
          <p className="hero-lead">{intro}</p>
        </div>
      </section>
      <section className="info-section">
        <div className="shell legal-grid">
          {sections.map((section) => (
            <article className="legal-card" key={section.heading}>
              <h3>{section.heading}</h3>
              <p>{section.text}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}

function ProductLanding({ product }) {
  return (
    <main>
      <section className="hero-section product-hero">
        <div className="shell">
          <p className="hero-kicker">Pénzügyi termék landing</p>
          <h1>{product.name}</h1>
          <p className="hero-lead">{product.description}</p>
          <ul className="highlight-list">
            {product.highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="calculator-section">
        <div className="shell calculator-wrap">
          <div>
            <h2>{product.name} kalkulátor</h2>
            <p>
              Töltsd ki az alapadatokat, és hasonlítsd össze az elérhető
              lehetőségeket.
            </p>
          </div>
          <div className="iframe-card">
            <iframe
              id={`bm-iframe-${product.slug}`}
              title={`${product.name} kalkulátor`}
              scrolling="no"
              width="360"
              height="590"
              src={IFRAME_SOURCES[product.slug]}
            />
          </div>
        </div>
      </section>

      <section className="info-section">
        <div className="shell info-grid">
          <article className="info-card">
            <h3>1. Érdeklődés és igényfelmérés</h3>
            <p>
              Néhány adat megadásával pontosabb képet kapsz arról, mely
              konstrukciók lehetnek megfelelőek a céljaidhoz.
            </p>
          </article>
          <article className="info-card">
            <h3>2. Ajánlatok összehasonlítása</h3>
            <p>
              Átláthatóan láthatod a költségeket és feltételeket, így könnyebb
              kiválasztani a legjobb ajánlatot.
            </p>
          </article>
          <article className="info-card">
            <h3>3. Szakértői támogatás</h3>
            <p>
              A döntés előtt és közben is segítséget kapsz, hogy magabiztosan
              haladj végig az igénylés folyamatán.
            </p>
          </article>
        </div>
      </section>
    </main>
  );
}

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div>
          <h4>SzemélyiKölcsön.com</h4>
          <p>
            Független pénzügyi összehasonlítás és tájékoztatás hitel,
            bankszámla és megtakarítás témában.
          </p>
        </div>
        <div>
          <h4>Termékek</h4>
          <ul>
            {PRODUCTS.map((product) => (
              <li key={product.slug}>
                <Link to={`/${product.slug}`}>{product.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4>Kapcsolat</h4>
          <ul>
            <li>Budapest</li>
            <li>info@szemelyikolcson.com</li>
            <li>+36 1 999 9999</li>
          </ul>
        </div>
        <div>
          <h4>Jogi</h4>
          <ul>
            <li>
              <Link to="/adatkezelesi-tajekoztato">Adatkezelési tájékoztató</Link>
            </li>
            <li>
              <Link to="/impresszum">Impresszum</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SiteHeader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        {PRODUCTS.map((product) => (
          <Route
            key={product.slug}
            path={`/${product.slug}`}
            element={<ProductLanding product={product} />}
          />
        ))}
        <Route
          path="/adatkezelesi-tajekoztato"
          element={
            <LegalPage
              title="Adatkezelési tájékoztató"
              intro="Az oldalon megadott személyes adatokat kizárólag ajánlatadás, ügyfélkapcsolat és jogszabályi megfelelés céljából kezeljük."
              sections={[
                {
                  heading: "Kezelt adatok köre",
                  text: "Név, e-mail cím, telefonszám, valamint a kalkuláció során megadott pénzügyi paraméterek. Az adatkezelés minden esetben célhoz kötött és arányos.",
                },
                {
                  heading: "Adatkezelés célja és jogalapja",
                  text: "Az adatkezelés célja ajánlatok előkészítése, ügyfél-visszahívás és kapcsolattartás. Jogalap: hozzájárulás, illetve egyes esetekben jogos érdek.",
                },
                {
                  heading: "Adatmegőrzés és adattovábbítás",
                  text: "Az adatokat csak a szükséges ideig őrizzük meg, és kizárólag a szolgáltatás nyújtásához szükséges pénzügyi partnerek részére továbbítjuk.",
                },
              ]}
            />
          }
        />
        <Route
          path="/impresszum"
          element={
            <LegalPage
              title="Impresszum"
              intro="A weboldal üzemeltetőjének és a szolgáltatásért felelős szervezetnek az adatai."
              sections={[
                {
                  heading: "Üzemeltető adatai",
                  text: "SzemélyiKölcsön.com Kft. Székhely: 1054 Budapest, Minta utca 10. Cégjegyzékszám: 01-09-123456. Adószám: 12345678-2-41.",
                },
                {
                  heading: "Elérhetőségek",
                  text: "E-mail: info@szemelyikolcson.com. Telefon: +36 1 999 9999. Ügyfélszolgálat: munkanapokon 9:00-17:00 között.",
                },
                {
                  heading: "Felelősségi nyilatkozat",
                  text: "Az oldalon szereplő tájékoztatás nem minősül teljes körű pénzügyi tanácsadásnak. A végleges feltételeket minden esetben a szerződéses dokumentumok tartalmazzák.",
                },
              ]}
            />
          }
        />
      </Routes>
      <SiteFooter />
    </BrowserRouter>
  );
}
